<ngx-loading [show]="loading"></ngx-loading>
<div>
  <div bsModal #setDatesModal="bs-modal" class="modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Set Extension Deadlines</h4>
        </div>
        <div class="modal-body">
          <form [formGroup]="addDateForm">
            <div class="form-group">
              <label for="name" style="margin-bottom: 0">Deadline</label>
              <div>
                <button
                  (click)="setDeadline('+30d', 'violationActionRequiredDeadline')"
                  type="button"
                  class="btn btn-sm btn-link"
                  style="padding: 3px 10px">
                  30 days
                </button>
                <button
                  (click)="setDeadline('+60d', 'violationActionRequiredDeadline')"
                  type="button"
                  class="btn btn-sm btn-link"
                  style="padding: 3px 10px">
                  60 days
                </button>
                <button
                  (click)="setDeadline('+90d', 'violationActionRequiredDeadline')"
                  type="button"
                  class="btn btn-sm btn-link"
                  style="padding: 3px 10px">
                  90 days
                </button>
              </div>
              <app-datepicker-input
                *ngIf="!loading"
                [validationStyle]="true"
                [formControl]="addDateForm.get('violationActionRequiredDeadline')">
              </app-datepicker-input>
              <small
                style="color: #dc3e3e"
                *ngIf="addDateForm.get('violationActionRequiredDeadline').hasError('dateInvalid')">
                Please select a date later than today.
              </small>
            </div>

            <div class="form-group">
              <label for="name" style="margin-bottom: 0">Reason</label>
              <textarea class="form-control" id="name" rows="3" formControlName="reason"></textarea>
            </div>
          </form>
          <br />

          <div style="text-align: right">
            <button type="button" class="btn btn-secondary" (click)="cancel()">Close</button>&nbsp;
            <button [disabled]="addDateForm.invalid" type="button" class="btn btn-primary" (click)="save()">
              Save changes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
